import { render, staticRenderFns } from "./sub_latihan.vue?vue&type=template&id=0a3b2e43&scoped=true&"
import script from "./sub_latihan.vue?vue&type=script&lang=js&"
export * from "./sub_latihan.vue?vue&type=script&lang=js&"
import style0 from "./sub_latihan.vue?vue&type=style&index=0&id=0a3b2e43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3b2e43",
  null
  
)

export default component.exports